import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'
import type { RefundPaymentStatusEnum } from './RefundPaymentStatusEnum'

@ObjectType()
@InputType('StripeRefundInput')
export class PaymentRefund {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('rfd') })
  _id: string

  @Field(() => Float)
  @Prop({ type: Number })
  amount: number

  /**
   * The external refundId, for the case of stripe, this is stripe's refundId
   */
  @Field(() => String)
  @Prop({ type: String })
  refundId: string

  @Field(() => String)
  @Prop({ type: String })
  remarks: string

  @Field(() => Date)
  @Prop({ type: Date })
  date: Date

  @Field(() => String)
  @Prop({ type: String, required: false })
  status?: RefundPaymentStatusEnum
}
